import { useState, useCallback, ReactElement } from 'react';
import type { MapControls } from 'three-stdlib';
import { CameraControls } from './CameraControls';
import { TransformControl } from './TransformControl';

export const Controls = (): ReactElement => {
  const [mapControls, setMapControls] = useState<MapControls>();

  const mouseDownHandler = useCallback(() => {
    if (!mapControls) return;
    Reflect.set(mapControls, 'enabled', false);
  }, [mapControls]);

  const mouseUpHandler = useCallback(() => {
    if (!mapControls) return;
    Reflect.set(mapControls, 'enabled', true);
  }, [mapControls]);

  return (
    <>
      <CameraControls setMapControls={setMapControls} />
      <TransformControl onMouseDown={mouseDownHandler} onMouseUp={mouseUpHandler} />
    </>
  );
};
